import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var FontMetrics = /** @class */ (function (_super) {
    __extends(FontMetrics, _super);
    function FontMetrics(emBox, strikethroughOffset, strikethroughThickness, underlineOffset, underlineThickness, subscriptOffset, subscriptScale, superscriptOffset, superscriptScale, lineGap) {
        if (lineGap === void 0) { lineGap = 0; }
        var _this = _super.call(this) || this;
        _this.emBox = emBox;
        _this.strikethroughOffset = +strikethroughOffset;
        _this.strikethroughThickness = +strikethroughThickness;
        _this.underlineOffset = +underlineOffset;
        _this.underlineThickness = +underlineThickness;
        _this.subscriptOffset = +subscriptOffset;
        _this.subscriptScale = +subscriptScale;
        _this.superscriptOffset = +superscriptOffset;
        _this.superscriptScale = +superscriptScale;
        _this.lineGap = +lineGap;
        return _this;
    }
    FontMetrics.forceNativeConstructor = true;
    FontMetrics.forceNativeMethods = true;
    return FontMetrics;
}(ASObject));
export { FontMetrics };
